// extracted by mini-css-extract-plugin
export default {"breadcrumbsRow":"up-z","breadcrumbForward":"vp-z","breadcrumbBack":"wp-z","selected":"xp-z"};